import { Button, Dialog } from '@mui/material'
import React from 'react'
import { toast } from 'react-toastify'

interface ConfimationModalProps {
  openState: [boolean, SetState<boolean>]
  warningText?: React.ReactNode // Normally just a string
  onConfirm: () => void
  confirmButtonText?: React.ReactNode // Normally just a string
  children?: React.ReactNode
  confirmButtonType?: 'delete' | 'other'
}
export const ConfirmationModal = ({
  openState,
  warningText,
  onConfirm,
  confirmButtonText,
  children,
  confirmButtonType = 'other',
}: ConfimationModalProps) => {
  const [isOpen, setIsOpen] = openState

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="sm" fullWidth>
      <div className="p-6 space-y-4">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold text-mm-neutral-1-900">Are you sure?</h2>
          {warningText && <p className="text-sm text-mm-neutral-1-600">{warningText}</p>}
        </div>
        {children}
        <div className="w-full flex justify-end gap-2 pt-4">
          <Button onClick={() => setIsOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color={confirmButtonType === 'delete' ? 'error' : 'primary'}
            onClick={() => {
              onConfirm()
              toast.info('Working on it — this may take a moment.')
              setIsOpen(false)
            }}
          >
            {confirmButtonText || 'Confirm'}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
